<template>
  <div :class="schema.settings.backgroundColor">
    <div class="ff__container" :style="{ 'max-width': schema.settings.maxWidth }">
      <split-wrapper
        :imageWidthClass="schema.settings.imageWidth"
        :backgroundColorClass="schema.settings.backgroundColor"
        :textAlignmentClass="schema.settings.textAlignment"
        :reversedClass="schema.settings.layout"
        :marginTop="schema.settings.marginTop"
        :marginBottom="schema.settings.marginBottom"
      >
        <template slot="image">
          <a
            class="ff__image ff__image--mobile"
            :href="schema.settings.ctaUrl"
            :style="
              `background-image: url(${schema.settings.imageMobile ||
                schema.settings.imageDesktop});`
            "
            :aria-label="schema.settings.subheader || schema.settings.preheader"
          ></a>
          <a
            class="ff__image ff__image--desktop hidden-sm"
            :href="schema.settings.ctaUrl"
            :style="`background-image: url(${schema.settings.imageDesktop});`"
            :aria-label="schema.settings.subheader || schema.settings.preheader"
          ></a>
        </template>
        <template slot="content">
          <div class="ff__main-wrap">
            <p
              class="preheader ff__preheader"
              :class="schema.settings.preheaderColor"
              v-if="schema.settings.preheader"
            >{{ schema.settings.preheader }}</p>
            <h5
              class="ff__header"
              :class="[schema.settings.headerColor]"
              v-if="schema.settings.header"
            >{{ schema.settings.header }}</h5>
            <p
              class="subheader ff__subheader"
              :class="schema.settings.subheaderColor"
              v-if="schema.settings.subheader"
            >{{ schema.settings.subheader }}</p>
            <div
              class="ff__body body-md client-generated"
              :class="{
                [schema.settings.bodyColor]: true,
                'ff-body-margin-bottom--none': !(
                  schema.settings.ctaText && schema.settings.ctaUrl
                )
              }"
              v-html="schema.settings.body"
              v-if="schema.settings.body"
            ></div>
            <div class="ff__cta-container">
              <component
                :is="
                  /link/.test(schema.settings.ctaStyle) ? 'v-link' : 'v-button'
                "
                tag="a"
                :class="schema.settings.ctaStyle"
                :href="schema.settings.ctaUrl"
                v-if="schema.settings.ctaText && schema.settings.ctaUrl"
              >{{ schema.settings.ctaText }}</component>
              <component
                :is="
                  /link/.test(schema.settings.ctaStyle2) ? 'v-link' : 'v-button'
                "
                tag="a"
                :class="schema.settings.ctaStyle2"
                :href="schema.settings.ctaUrl2"
                v-if="schema.settings.ctaText2 && schema.settings.ctaUrl2"
              >{{ schema.settings.ctaText2 }}</component>
            </div>
          </div>
        </template>
      </split-wrapper>
    </div>
  </div>
</template>

<script>
import VButton from '../buttons/VButton.vue';
import VLink from '../buttons/VLink.vue';
import SplitWrapper from '../basic/SplitWrapper.vue';

export default {
  name: 'FiftyFifty',
  props: {
    schema: Object,
  },
  computed: {},
  components: {
    VButton,
    VLink,
    SplitWrapper,
  },
};
</script>

<style lang="scss">
.ff {
  &__container {
    margin: 0 auto;

    @include mobile-only {
      .sw__main.text-center {
        .ff__main-wrap {
          margin: 0 auto;
        }
        .ff__cta-container {
          align-items: center;
        }
      }
    }
  }

  &__main-wrap {
    max-width: 350px;

    @include mobile-only {
      max-width: 300px;
    }
  }

  &__main-wrap > * {
    margin-bottom: 8px;
  }

  &__main-wrap > *:last-child {
    margin-bottom: 0;
  }

  &__preheader {
    margin-bottom: 24px;
  }

  &__header {
    @include tablet-up {
      margin-bottom: 16px;
    }
  }

  &__body {
    margin-bottom: 32px;
  }

  &__body-margin-bottom--none {
    margin-bottom: 0;
  }

  .sw &__image--desktop {
    display: none;
  }

  .button {
    margin: 0;
  }

  &__cta-container {
    @include mobile-only {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .button {
      display: block;
      margin-bottom: 16px;

      @include tablet-up {
        display: inline-block;
        margin: 0;

        &:not(:last-child) {
          margin-right: 16px;
        }
      }
    }
  }

  @include tablet-up {
    .sw &__image--mobile {
      display: none;
    }

    .sw &__image--desktop {
      display: block;
    }

    .sw__main {
      padding: 5%;
    }
  }
}
</style>
